import { getCurrentThemeConfig } from '@app/core/theme-config';
import { getConfig } from '@services/app.config.loader';

export function loadChatService() {
    if (!getCurrentThemeConfig().chatEnabled) return;
    if (window['amazon_connect']) return;

    //SVG for widget Agent Icon
    const agentSVG = `<svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.9726 7.73646L11.7988 0.403998C11.5238 0.196471 11.3864 0.0927124 11.2489 0.0927124C11.1114 0.0927124 10.9739 0.196471 10.6989 0.403998L0.490783 7.73646C0.181443 7.94398 0.0439525 8.32444 0.00958252 8.53196V15.9682H1.41879V14.9652C1.41879 12.8899 1.93435 12.2674 3.75601 11.2298C4.92462 10.5726 5.0621 10.3997 5.0621 9.98463C5.0621 9.56958 4.82151 9.46582 3.96223 9.46582H3.37792L3.27481 9.98463H1.55627V8.04775C2.48429 7.80565 3.75601 7.73647 4.58091 7.73647C7.08999 7.73647 7.91489 8.49738 7.91489 9.77711C7.91489 10.9185 7.43369 11.3335 7.02124 11.6794C6.60879 12.0599 4.37468 13.305 4.37468 13.305H7.15873V15.9682H9.83966V9.95004L8.32734 10.8839V9.11995L10.6302 7.84023H13.0018V15.9682H16.0952C14.1017 15.5532 13.6548 14.1005 13.6548 12.302V11.541C13.6548 9.39664 14.3079 7.73647 17.3669 7.73647C20.4259 7.73647 21.0789 9.39664 21.0789 11.541V12.302C21.0789 14.1005 20.5978 15.5532 18.6386 15.9682H22.4882V8.53197C22.4538 8.32444 22.3163 7.94397 21.9726 7.73646ZM9.08712 13.305V14.308H7.91851V13.305H9.08712Z" fill="#BC2559"/>
<path d="M17.3325 14.2042C17.8824 14.2042 17.9855 13.893 17.9855 12.2674V11.5065C17.9855 9.88087 17.8824 9.56958 17.3325 9.56958C16.7826 9.56958 16.6794 9.88087 16.6794 11.5065V12.2674C16.6794 13.9275 16.7826 14.2042 17.3325 14.2042Z" fill="#BC2559"/>
</svg>`
    //TODO Have hardcoded values pulled from theme config if we open this up to other brands.
    const SVGblob =  new Blob([agentSVG], { type: "image/svg+xml" });
    //Create and store URL for amazon API
    const iconUrl = URL.createObjectURL(SVGblob);
    localStorage.setItem('iconUrl', iconUrl);
    //Widget Client ID from Connect
    const clientId = getConfig('chatClientID');
    //Widget SnippetID from Connect generated script.
    const snippetId = getConfig('chatWidgetID');
    //used to set chat box size
    const isMobile = /Mobi | Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || 'ontouchstart' in window || window.innerWidth <= 768;
    //AWS generated script
    (function (w, d, x, id) {

        var s = d.createElement('script');
        s.src = 'https://dend6g4sigg57.cloudfront.net/amazon-connect-chat-interface-client.js';
        s.async = 1;
        s.id = id;
        d.getElementsByTagName('head')[0].appendChild(s);
        w[x] = w[x] || function () { (w[x].ac = w[x].ac || []).push(arguments) };
    })(window, document, 'amazon_connect', clientId);

    amazon_connect('styles', { iconType: 'CHAT', openChat: { color: '#ffffff', backgroundColor: '#BC2559' }, closeChat: { color: '#ffffff', backgroundColor: '#BC2559'} });
    amazon_connect('snippetId', snippetId);
    amazon_connect('supportedMessagingContentTypes', ['text/plain']);
    //Set customer name, gives agent dynamic tab names in chat
    amazon_connect('customerDisplayName', function (callback) {
        callback(window['chatDisplayName']);
    });
    amazon_connect('customStyles', {
        global: {
            frameWidth: isMobile ? '100%' : '400px',
            frameHeight: isMobile ? '100%' : '600px',
        },
        footer: {
            footerBackgroundColor: '#F5F5F5',
            buttonFontSize: '16px',
            buttonBackgroundColor: '#FFFFFF'
        },
    });
    amazon_connect('customizationObject', {
        header: {
            dropdown: true
        },
        footer: {
            disabled: false,
        },
        transcript: {
            displayIcons: true,
            iconSources: {
                agentMessage: localStorage.getItem("iconUrl")
            },
            hideDisplayNames: true,
            messageFontSize: "16px"
        }
    });

    //ContactAttributes set here as key/value pairs
    window['chatDisplayName'] = '';
    window['chatAttributes'] = {
        tenant: 'HBW210',
        firstName: '',
        lastName: '',
        PropertyAddress: '',
        ContractId: '',
        originatingSite: '210-re-portal',
        Referrer: window.location.href,
    };

    amazon_connect('contactAttributes', window['chatAttributes']);

    if ('navigation' in window) {
        window.navigation.addEventListener("navigate", (event) => {
            updateChatAttributes({Referrer: event.destination.url})
        });
    }
}

export function updateChatAttributes(updates) {
    if (!getCurrentThemeConfig().chatEnabled) return;
    if (!window['chatAttributes']) return;
    for (const [key, value] of Object.entries(updates)) {
        window['chatAttributes'][key] = value;
    }
}
